export default "__VITE_ASSET__Bh621FWM__ 60w, __VITE_ASSET__CM8xrrTP__ 120w, __VITE_ASSET__qpFYBIds__ 130w";